import script from "./TestForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./TestForm.vue?vue&type=script&lang=ts&setup=true"

import "./TestForm.vue?vue&type=style&index=0&id=393b0308&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-393b0308"]])

export default __exports__